import { makeStyles } from '@material-ui/core';

export const useLeadFormStyles = makeStyles((theme) => {
  return {
    root: {
      padding: theme.spacing(1),
    },
    field: {
      margin: theme.spacing(1),
    },
    selectContainer: {
      display: 'flex',
      margin: theme.spacing(1),
      alignItems: 'center',
    },
    selectLabel: {
      margin: theme.spacing(0, 1, 0, 0),
    },
    button: {},
  };
});